export const isValidSolutionFilename = (filename) => filename.endsWith('.json');

export const parseSolutionJson = (json) => {
  const parsed = JSON.parse(json);
  const isUnassignedOnly = parsed?.tours?.length === 0 && !!(parsed.notices || parsed.unassigned);
  return { parsed, isUnassignedOnly };
};

